
  <input
  type="text"
  id="toWhere"
  name="c2y"
  class="routeInputs"
  placeholder="Введіть населений пункт та виберіть зі списку"
  (keyup)="onKey($event)"
  (blur)="onBlurMethod( $event )"
  [(ngModel)]="cityValue"
  minlength="2"
  autocomplete="off"
  > 
  
  